/**
 * 在庫価格ファイルステータス
 */
const StockPriceStatusCode = {
  /**  システムエラー */
  SYSTEM_ERROR: '6',
  /**  完了 */
  COMPLETED: '7',
  /**  中止 */
  ABORT: 'J',
  /**  ファイルフォーマットエラー */
  FILE_FORMAT_ERROR: 'D',
  /**  スケジュール済み */
  BUSY: 'A',
  /**  取込中 */
  CSV_BEING_IMPORTED: 'B',
} as const;

type StockPriceStatusCode = typeof StockPriceStatusCode[keyof typeof StockPriceStatusCode];

/**
 * コード名称取得
 * @param status ファイルステータスコード
 * @return コード名称
 */
export function getName(status: StockPriceStatusCode) {
  switch (status) {
    case StockPriceStatusCode.SYSTEM_ERROR:
      return 'システムエラー';
    case StockPriceStatusCode.COMPLETED:
      return '完了';
    case StockPriceStatusCode.ABORT:
      return '中止';
    case StockPriceStatusCode.FILE_FORMAT_ERROR:
      return 'ファイルフォーマットエラー';
    case StockPriceStatusCode.BUSY:
      return 'スケジュール済み';
    case StockPriceStatusCode.CSV_BEING_IMPORTED:
      return '取込中';
    default:
      return '';
  }
}

export default StockPriceStatusCode;
